var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgOffsetIcon = function SvgOffsetIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1a7 7 0 1 1 0 14v-1.5c1.469 0 2.85-.572 3.889-1.611S15.5 9.469 15.5 8s-.572-2.85-1.611-3.889S11.469 2.5 10 2.5s-2.85.572-3.889 1.611A5.46 5.46 0 0 0 4.591 7H7.5L4 11 .5 7h2.571A7 7 0 0 1 10 1m3 6v2H9V4h2v3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOffsetIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;